export const connectionlist = [
  {
    id: "connect1",
    d: "M80 440c0 71-35.5 119-35.5 164.5"
  },
  {
    id: "connect2",
    d: "M145.5 339.5c0 170-101 219.5-101 265"
  },
  {
    id: "connect3",
    d: "M212.5 404.5c0 106-28 116-28 211"
  },
  {
    id: "connect4",
    d: "M269.5 219.5c0 244-85 301-85 396"
  },
  {
    id: "connect5",
    d: "M336.5 353.5c0 157-152 167-152 262"
  },
  {
    id: "connect6",
    d: "M380.5 377.5c0 133-196 145-196 238"
  },
  {
    id: "connect7",
    d: "M336.5 353.5c0 51.24-17 155.87-17 252"
  },
  {
    id: "connect8",
    d: "M402.5 114.5c0 346 23 395 23 491"
  },
  {
    id: "connect9",
    d: "M446.5 240.5c0 223-21 271-21 365"
  },
  {
    id: "connect10",
    d: "M501.5 337.5c0 129.5-76 172-76 268"
  },
  {
    id: "connect11",
    d: "M336.5 353.5c0 157 192 176 192 272"
  },
  {
    id: "connect12",
    d: "M380.5 377.5c0 133 148 152 148 248"
  },
  {
    id: "connect13",
    d: "M502 337.5C502 468 530 534 529 625"
  },
  {
    id: "connect14",
    d: "M536.5 371.5c0 92-8 111-8 254"
  },
  {
    id: "connect15",
    d: "M547.5 211.5c0 299-19 318-19 414"
  },
  {
    id: "connect16",
    d: "M570.5 144.5c-1 366-42 385-42 481"
  },
  {
    id: "connect17",
    d: "M623.5 296.5c2 214-95 233-95 329"
  },
  {
    id: "connect18",
    d: "M623.5 296.5c0 214 22 233 22 329"
  },
  {
    id: "connect19",
    d: "M669.5 409.5c0 101-24 120-24 216"
  },
  {
    id: "connect20",
    d: "M669.5 409.5c0 101 96 149 96 196"
  },
  {
    id: "connect21",
    d: "M681.5 327.5c0 183 84 182 84 278"
  },
  {
    id: "connect22",
    d: "M701.5 107.5c0 403 64 402 64 498"
  },
  {
    id: "connect23",
    d: "M736.5 221.5c0 289 29 288 29 384"
  },
  {
    id: "connect24",
    d: "M769.5 324.5c0 186-4 185-4 281"
  },
  {
    id: "connect25",
    d: "M824.5 462.5c0 48-59 96-59 143"
  },
  {
    id: "connect26",
    d: "M980.5 386.5c0 77-215 172-215 219"
  },
  {
    id: "connect27",
    d: "M824.5 462.5c0 48.68 70 95 70 143"
  },
  {
    id: "connect28",
    d: "M903.5 245.5c0 218-9 264-9 360"
  },
  {
    id: "connect29",
    d: "M980.5 386.5c0 77 52 123 52 219"
  }
];
